<template>
  <div>
    <rabbey-toolbox :filterables="true" @filter-search="handleSearch" />

    <rabbey-table2
      ref="table"
      index-url="/api/deviceAssignations"
      key-search="CustomerName"
      :search="search"
      :filterList="custList"
      :columns="columns"
    ></rabbey-table2>
  </div>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  name: "DeviceAssignmentList",
  data() {
    return {
      search: "",
      custList: [],
      columns: [
        {
          prop: "Serial",
          name: "Serial",
          columnKey: "Serial",
          minWidth: 140
        },
        {
          prop: "IMEI",
          name: "IMEI",
          columnKey: "EMEI",
          minWidth: 140
        },
        {
          prop: "SIMNumber",
          name: "SIM",
          width: 130
        },
        {
          prop: "CustomerName",
          name: "Cliente",
          minWidth: 300
        },
        {
          prop: "ContactName",
          name: "Contacto"
        },
        {
          prop: "Product.Description",
          name: "Producto",
          width: 100,
          formatter: (row) => row.Product.Description
        },
        {
          prop: "ContractCode",
          name: "Contrato",
          minWidth: 140
        },
        {
          prop: "AssginationStart",
          name: "Fecha desde",
          width: 200,
          formatter: (row) => {
            return this.formatDate(row.AssignationStart);
          }
        }
      ]
    };
  },
  methods: {
    formatDate,
    handleSearch(search) {
      if (search.length > 0) {
        this.$http
          .get("/api/deviceassignations/by", {
            params: {
              serial: search,
              customername: search,
              simnumber: search
            }
          })
          .then((response) => {
            this.search = search;
            this.custList = response.data.Items;
            this.$refs.table.refreshTable();
          })
          .catch((error) => {
            if (error.message.includes("404")) {
              const h = this.$createElement;
              this.$message({
                type: "info",
                message: h("p", null, [
                  h("span", null, "Registro no encontrado"),
                  h("i", { style: "color: teal" }, "cambie su consulta")
                ])
              });
            } else {
              this.$alert(error.message, error.name, {
                type: "error"
              });
            }
          });
      } else {
        this.custList = [];
        this.search = "";
        this.$refs.table.refreshTable();
      }
    }
  }
};
</script>
